export const htmlTagsInTextRemover = (text: string) => {
	return text.replace(/(<([^>]+)>)/gi, "");
};
